import React from "react";
import useClasses from "hooks/useClasses";
import Table from "components/Shared/CustomTable/Table/Table";
import Button from "components/Shared/CustomButtons/Button";
import Modal from "components/Shared/CustomModal/CustomModal";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import EditIcon from "@mui/icons-material/Edit";

import CompanyAdminForm from "./CompanyAdminForm";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  createModalHeader: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#fff",
    padding: "0 10px",
    borderRadius: "15px 15px 0 0",
  },
  createModalTitle: {
    fontWeight: 900,
  },
  createModalBody: {
    padding: "15px",
    maxHeight: "450px",
    overflowY: "scroll",
  },
});

export default function CompanyAdmin({
  rows,
  totalRows,
  rowsPerPage,
  setRowsPerPage,
  order,
  setOrder,
  orderBy,
  setOrderBy,
  page,
  setPage,
  searchValue,
  searchHandler,
  selectedSearchBy,
  handleSearchByChange,

  companies,
  createUser,
  deleteUser,
  updateUser,
  changeStatus,
}) {
  const classes = useClasses(styles);
  const [selected, setSelected] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [openCreateModal, setOpenCreateModal] = React.useState(false);
  const [modalContent, setModalContent] = React.useState(null);
  const [isNewUser, setIsNewUser] = React.useState(false);
  const [updatedRow, setUpdatedRow] = React.useState(null);

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleDelete = (id) => {
    if (id) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="error"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>Are You sure want to delete this user ? </h5>
          <div>
            <Button color="danger" size="lg" onClick={() => deleteUser(id)}>
              Delete
            </Button>
            <Button
              color="secondary"
              size="lg"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    } else if (selected.length !== 0) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="error"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>Are You sure want to delete those users ? </h5>
          <div>
            <Button
              color="danger"
              size="lg"
              onClick={() => deleteUser(selected)}
            >
              Delete
            </Button>
            <Button
              color="secondary"
              size="lg"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    }
    setOpenModal(true);
  };
  const handleStatusChange = (id) => {
    if (id) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="secondary"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>
            Are You sure want to Activate/Disactivate this Company Admin ?{" "}
          </h5>
          <div>
            <Button color="primary" size="lg" onClick={() => changeStatus(id)}>
              Activate/Disactivate
            </Button>
            <Button
              color="secondary"
              size="lg"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    } else if (selected.length !== 0) {
      setModalContent(
        <div style={{ textAlign: "center" }}>
          <ErrorOutlineRoundedIcon
            color="secondary"
            style={{ width: "100px", height: "100px" }}
          />
          <h5>
            Are You sure want to Activate/Disactivate those Company Admin ?{" "}
          </h5>
          <div>
            <Button
              color="primary"
              size="lg"
              onClick={() => changeStatus(selected)}
            >
              Activate/Disactivate
            </Button>
            <Button
              color="secondary"
              size="lg"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      );
    }
    setOpenModal(true);
  };
  const handleUpdate = (row) => {
    if (row.id) {
      setUpdatedRow(row);
      setIsNewUser(false);
      setOpenCreateModal(true);
    }
  };

  const selectedToolbarButtons = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Button color="danger" aria-label="delete" onClick={() => handleDelete()}>
        Delete Selected
      </Button>
      <Button
        color="primary"
        aria-label="change status"
        onClick={() => handleStatusChange()}
      >
        Change Status
      </Button>
    </div>
  );

  const toolbarButtons = (
    <div>
      <Button
        color="primary"
        onClick={() => {
          setUpdatedRow(null);
          setIsNewUser(true);
          setOpenCreateModal(true);
        }}
      >
        Add new Company Admin
      </Button>
    </div>
  );

  const searchByOptions = [
    {
      value: "display_name",
      label: "Name",
    },
    {
      value: "email",
      label: "Email",
    },
    {
      value: "company_name",
      label: "Company Name",
    },
  ];

  const headCells = [
    {
      id: "display_name",
      sortable: true,
      label: "Name",
    },
    { id: "email", sortable: true, label: "Email" },
    { id: "role", sortable: true, label: "Role" },
    {
      id: "company_name",
      sortable: true,
      label: "Company Name",
    },
    { id: "is_active", sortable: true, label: "User Active" },
    { id: "is_email_verified", sortable: true, label: "Email Verified" },
    { id: "options", sortable: false, label: "Options" },
  ];

  const tableCells = (
    <>
      {rows.length !== 0 ? (
        rows.map((row, index) => {
          const isItemSelected = isSelected(row.id);
          const labelId = `enhanced-table-checkbox-${index}`;

          return (
            <TableRow key={row.id} hover>
              <TableCell padding="checkbox">
                <Checkbox
                  onClick={(event) => handleClick(event, row.id)}
                  checked={isItemSelected}
                  inputProps={{ "aria-labelledby": labelId }}
                  color="primary"
                />
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.display_name}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.email}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.role}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.company_name}
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                <div>
                  <div style={{ margin: "10px auto" }}>
                    <span style={{ fontSize: "1rem", fontWeight: "bold" }}>
                      {row.is_active === 1 ? "Active" : "Not Active"}
                    </span>
                  </div>
                  <div>
                    <Button
                      color={row.is_active === 1 ? "danger" : "primary"}
                      aria-label="change"
                      onClick={() => handleStatusChange([row.id])}
                    >
                      {row.is_active === 1 ? "Deactivate" : "Activate"}
                    </Button>
                  </div>
                </div>
              </TableCell>
              <TableCell
                component="th"
                id={labelId}
                scope="row"
                padding="normal"
                align="center"
              >
                {row.is_email_verified === 1 ? (
                  <Tooltip title="email verified">
                    <i className="fas fa-user-check"></i>
                  </Tooltip>
                ) : (
                  <Tooltip title="email not verified">
                    <i className="fas fa-user-times"></i>
                  </Tooltip>
                )}
              </TableCell>
              <TableCell component="th" padding="normal" align="center">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Tooltip title="Edit Company Admin">
                    <IconButton
                      aria-label="edit"
                      onClick={() => handleUpdate(row)}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete Company Admin">
                    <IconButton
                      aria-label="delete"
                      onClick={() => handleDelete([row.id])}
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          );
        })
      ) : (
        <TableRow>
          <TableCell colSpan={12} align="center">
            No Company Admin
          </TableCell>
        </TableRow>
      )}
    </>
  );
  return (
    <React.Fragment>
      <Table
        rows={rows}
        totalRows={totalRows}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        page={page}
        setPage={setPage}
        searchHandler={searchHandler}
        searchValue={searchValue}
        selectedSearchBy={selectedSearchBy}
        handleSearchByChange={handleSearchByChange}
        tableCells={tableCells}
        selected={selected}
        setSelected={setSelected}
        headCells={headCells}
        isSelectable={true}
        selectedToolbarButtons={selectedToolbarButtons}
        toolbarButtons={toolbarButtons}
        showSearchBy={true}
        searchByOptions={searchByOptions}
        showFilter={false}
        filterTitle={""}
        selectedFilter={null}
        handleFilterChange={null}
        filterOptions={null}
        handleFilterReset={null}
      />
      <Modal open={openModal} handleClose={() => setOpenModal(false)}>
        {modalContent}
      </Modal>
      <Modal
        open={openCreateModal}
        handleClose={() => setOpenCreateModal(false)}
        customStyle={{ width: "100%", maxWidth: "500px", padding: 0 }}
      >
        <div className={classes.createModalHeader}>
          <span className={classes.createModalTitle}>
            {isNewUser ? `Add New Company Admin` : `Edit Company Admin`}
          </span>
          <IconButton
            aria-label="close"
            onClick={() => setOpenCreateModal(false)}
          >
            <CloseIcon style={{ color: "#fff" }} />
          </IconButton>
        </div>
        <div className={classes.createModalBody}>
          <CompanyAdminForm
            isNewUser={isNewUser}
            updateUser={updateUser}
            userUpdateData={updatedRow}
            createUser={createUser}
            companies={companies}
          />
        </div>
      </Modal>
    </React.Fragment>
  );
}
